import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import {
  SectionContentWrapper,
  SectionContentContainer,
  SectionContentBackground,
  SectionTitle,
  SectionHeader,
  SectionBody,
} from './SectionContent.styled';
import SectionButton from '../SectionButton';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';

const SectionModal = dynamic(() => import('../SectionModal'), { ssr: false });

const eventLabels = {
  flooring: 'flooring',
  framing: 'framing',
  'cabinet shop': 'cabinet',
  'roof build': 'roof',
  'final finish': 'finish',
};

const SectionContent = ({
  alt,
  matterportUrl,
  gaLabel,
  title,
  header,
  body,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <SectionContentWrapper alt={alt}>
      <SectionContentContainer>
        <SectionTitle className="section-title">{title}</SectionTitle>
        <SectionHeader className="section-header">{header}</SectionHeader>
        <SectionBody className="section-body">{body}</SectionBody>
        <SectionButton
          className="section-button"
          onClick={() => {
            openModal();
            const matterportTitle = `dtr_ift_${
              eventLabels[title.toLowerCase()]
            }_matterport`;
            pushGTMEvent('ch.cta_click', matterportTitle, {
              location: 'Interactive Facility Tour',
              category: 'home_education',
              action: 'button',
              label: matterportTitle,
            });
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          matterportUrl={matterportUrl}
          gaLabel={gaLabel}
        />
        <SectionContentBackground hovered={isHovered} />
        {modalIsOpen && (
          <SectionModal isOpen={modalIsOpen} closeModal={closeModal}>
            <iframe
              title="matterport"
              width="100%"
              height="100%"
              src={matterportUrl}
            />
          </SectionModal>
        )}
      </SectionContentContainer>
    </SectionContentWrapper>
  );
};

SectionContent.propTypes = {
  alt: PropTypes.any,
  body: PropTypes.any,
  children: PropTypes.any,
  gaLabel: PropTypes.string,
  header: PropTypes.any,
  matterportUrl: PropTypes.string,
  title: PropTypes.string,
};

SectionContent.defaultProps = {
  alt: '',
  children: undefined,
  matterportUrl: '',
  gaLabel: '',
};

export default SectionContent;
